import { setupReact } from "../../assets/javascripts/lib/setupReact"

setupReact(
  import.meta.glob('../../assets/javascripts/top-level-components/application/*.tsx', { eager: true })
)
